export const messages = {
  en: {
    menuGroupCatalogManage: {
      menuGroup: 'Menu Group',
      number: 'Number',
      menuGroupId: 'Menu Group ID',
      operation: 'Operation',
      delete: 'Delete'
    },
    addMenuGroupCatalog: {
      addCatalogGroup: 'Add Catalog Group',
      menuGroup: 'Menu Group',
      requiredSelect: 'Required, please select menu group',
      cancel: 'Cancel',
      save: 'Save'
    },
    deleteMenuGroupCatalog: {
      confirmOperation: 'Please confirm your operation',
      confirmDeleteCatalogGroup: 'Confirm to delete catalog group',
      wrongClick: 'Wrong click',
      confirmDelete: 'Confirm Delete'
    }
  },
  zh: {
    menuGroupCatalogManage: {
      menuGroup: '菜单组',
      number: '编号',
      menuGroupId: '菜单组ID',
      operation: '操作',
      delete: '删除'
    },
    addMenuGroupCatalog: {
      addCatalogGroup: '添加目录组',
      menuGroup: '菜单组',
      requiredSelect: '必填，请选择菜单组',
      cancel: '取消',
      save: '保存'
    },
    deleteMenuGroupCatalog: {
      confirmOperation: '请确认您的操作',
      confirmDeleteCatalogGroup: '确定删除目录组',
      wrongClick: '点错了',
      confirmDelete: '确认删除'
    }
  }
}